// scrollState.js — S-B4 pure auto-scroll logic (node-testable, no JSX, no DOM).
//
// The thread auto-sticks to the bottom while a reply streams, but must NOT yank the
// user back down if they have scrolled up to read history, and must NOT re-scroll on
// chat-switch / shrink / no-growth (those are not "new content arriving at the bottom").
//
// Consumed by AgentStudioChat.jsx, which owns the refs/effect/ResizeObserver wiring.

// Distance (px) from the bottom within which we consider the thread "parked at bottom".
export const NEAR_BOTTOM_PX = 80

// True when the scroll position is within `t` px of the bottom.
// distance-from-bottom = scrollHeight - scrollTop - clientHeight.
export function isNearBottom({ scrollHeight, scrollTop, clientHeight }, t = NEAR_BOTTOM_PX) {
  const distance = scrollHeight - scrollTop - clientHeight
  return distance <= t
}

// Stick to bottom ONLY when content GREW (new content arrived) AND the user has not
// scrolled up. Never stick on no-growth, shrink, or chat-switch (newLen <= prevLen),
// and never override a user who scrolled up to read.
export function shouldStickToBottom(prevLen, newLen, userScrolledUp) {
  if (newLen <= prevLen) return false
  return !userScrolledUp
}
